/* Column flex shell: the notification list fills the available height and
 * the clipboard dock sits below it as a flex child sized by its own content.
 * `min-height: 0` lets the scrollable list shrink inside the flex column
 * instead of overflowing. */
.shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.main {
  flex: 1 1 auto;
  min-height: 0;
}
